// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"21697f17eaafdce7","node_modules_canvg_lib_index_es_js":"b433fe4df150cde5","node_modules_firebase_compat_messaging_dist_esm_index_esm_js":"622431eb901f958a"}[chunkId] + ".js";
};